import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid="payment-cancel-page">
      <div className="w-full max-w-md glass rounded-2xl p-8 text-center">
        <XCircle className="h-16 w-16 text-slate-400 mx-auto" />
        <h1 className="font-display text-2xl font-bold text-white mt-4">Payment cancelled</h1>
        <p className="text-slate-400 mt-2 text-sm">You were not charged. You can resume the purchase anytime.</p>
        <Button className="btn-gold mt-6 w-full" onClick={() => nav("/courses")}>Back to courses</Button>
      </div>
    </div>
  );
}
